import React from 'react';
import PropTypes from 'prop-types';
import Cookie from 'js-cookie';
import {CLOSE__16} from '@homeaway/svg-defs/lib/defs/CLOSE__16';
import {ButtonIcon} from '@homeaway/react-buttons';
import './TransitionBanner.less';
import {Logo, Vmark} from './svgs';
import triggerEdapEvent from '../../util/edap';

class TransitionBanner extends React.Component {
    static propTypes = {
        /** Whether the banner is post or pre brand transition**/
        forPreTransition: PropTypes.bool,
        /** Title for the banner **/
        title: PropTypes.string,
        /** Info for the banner **/
        info: PropTypes.string,
        /** Whether to display banner based on cookie value, for ease of development **/
        useCookie: PropTypes.bool,
        /** Whether the cookie should be saved only after the user closes the banner **/
        useCookieOnClose: PropTypes.bool
    }

    static defaultProps = {
        forPreTransition: true,
        title: 'Title',
        info: 'Info',
        useCookie: true,
        useCookieOnClose: false
    }

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.closePopover = this.closePopover.bind(this);

        this.bannerType = this.props.forPreTransition ? 'Pre' : 'Post';
        this.cookieName = `seen${this.bannerType}TransBanner`;

        this.showBanner = this.props.useCookie ? !Cookie.get(this.cookieName) : true;
    }

    componentDidMount() {
        // Set cookie if component mounted, if useCookie is set
        if (this.props.useCookie && !this.props.useCookieOnClose) {
            Cookie.set(this.cookieName, 'true');
            this.handleGDPRTermsAccept(this.cookieName);
        }
        // Show after mounted, to prevent floating images before full render
        this.setState({isOpen: true});
        if (this.showBanner) {
            triggerEdapEvent({
                eventaction: `${this.bannerType.toLocaleLowerCase()}branding pop up seen`
            });
        }
    }

    handleGDPRTermsAccept(cookieName) {
        window.cookieconsent = window.cookieconsent || [];
        window.cookieconsent.push(function(cookieAccess) {
            cookieAccess.setCookie('functional', `${cookieName}=true`);
        });
    }

    closePopover() {
        this.setState({isOpen: false});
        if (this.props.useCookie && this.props.useCookieOnClose) {
            Cookie.set(this.cookieName, 'true');
            this.handleGDPRTermsAccept(this.cookieName);
        }
        triggerEdapEvent({
            eventaction: `${this.bannerType.toLocaleLowerCase()}branding pop up closed`
        });
    }

    /* eslint-disable complexity */
    render() {
        return (
            this.state.isOpen && this.showBanner &&
            <div>
                <div className="transition-banner__caret" />
                <div role="dialog" className={`transition-banner${ this.props.forPreTransition ? '' : ' transition-banner__post'}`}>
                    <Vmark />
                    <div className="transition-banner__content front">
                        {
                            this.props.forPreTransition && <Logo />
                        }
                        <div>
                            <ButtonIcon
                                label="close"
                                size="sm"
                                inverse
                                svgMarkup={CLOSE__16}
                                className="transition-banner__close front"
                                onClick={this.closePopover}
                            />
                        </div>
                        <div className={`transition-banner__title ${ this.props.forPreTransition ? '' : 'transition-banner__title__post'} front`}>
                            {this.props.title}
                        </div>
                        <div className={`transition-banner__info front ${ this.props.forPreTransition ? '' : 'transition-banner__info__post'} front`}
                            dangerouslySetInnerHTML={{__html: this.props.info}}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default TransitionBanner;

